import React from 'react';
import Icon from 'components/mweb/Icon/Icon';
import Button from '../../common/Button/Button';
import Input from 'components/mweb/Input/Input';
import Drawer from 'components/common/Drawer';
import axisLogo from '../../../assets/bank-logos/axis.png';
import sbiLogo from '../../../assets/bank-logos/sbi.png';
import iciciLogo from '../../../assets/bank-logos/icici.png';
import hdfcLogo from '../../../assets/bank-logos/hdfc.png';
import kotak from '../../../assets/bank-logos/kotak.png';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { PAYMENT_GATEWAYS } from 'hb-redux-store/util/constantServices';

const NetBanks = props => {
  const {
    title,
    details,
    selectedMode,
    onPaymentModeChange,
    onPlaceOrder,
    pgId,
    ctaText = 'Place Order',
  } = props;
  let shortListBank = [
    { name: 'ICICI', code: 'ICIC', image: iciciLogo },
    { name: 'HDFC', code: 'HDFC', image: hdfcLogo },
    { name: 'SBI', code: 'SBIN', image: sbiLogo },
    { name: 'Kotak', code: 'KKBK', image: kotak },
    { name: 'Axis', code: 'UTIB', image: axisLogo },
  ];
  if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
    shortListBank = [
      { name: 'ICICI', code: 'ICIB', image: iciciLogo },
      { name: 'HDFC', code: 'HDFB', image: hdfcLogo },
      { name: 'SBI', code: 'SBIB', image: sbiLogo },
      { name: 'Kotak', code: '162B', image: kotak },
      { name: 'Axis', code: 'AXIB', image: axisLogo },
    ];
  }
  const trimmedList = details
    .map(allBank => shortListBank.find(bank => bank.code === allBank.code))
    .filter(b => !!b);
  const [showMoreBanks, setMoreBanksModal] = React.useState(false);
  const [searchKey, setSearchKey] = React.useState('');
  const [bankList, setBankList] = React.useState(
    details.map(bank => ({ ...bank, isSelected: selectedMode === bank.code }))
  );
  const onCancel = () => setMoreBanksModal(false);
  const filterBanks = ({ searchKey }) => {
    setSearchKey(searchKey);
    onPaymentModeChange(null);
    setBankList(
      details.filter(
        bank => bank.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1
      )
    );
  };
  const selectNetBank = bankCode => {
    onPaymentModeChange(bankCode);
    setBankList(
      bankList.map(bank => ({ ...bank, isSelected: bankCode === bank.code }))
    );
  };
  const onPay = () => {
    //validate data, show errors or call onPlaceOrder
    if (selectedMode) {
      const payDetails = {
        bank: selectedMode,
        method: 'netbanking',
        mode: 'pol',
        payVia: 'netbanking',
      };
      if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
        payDetails.pg = 'NB';
        payDetails.bankcode = selectedMode;
      }
      onPlaceOrder(payDetails);
    } else {
      setAppNotification('No payment mode selected.');
    }
  };
  return (
    <React.Fragment>
      <div className="desktop-payment-mode-panel">
        <div className="desktop-payment-mode-panel--title">{title}</div>
        {trimmedList && trimmedList.length > 0 && (
          <React.Fragment>
            <div className="desktop-payment-mode-panel--net-banks">
              {/*style={{width: (100/trimmedList.length) + '%'}}*/}
              {trimmedList.map(bank => {
                return (
                  <div
                    onClick={() => onPaymentModeChange(bank.code)}
                    className={`desktop-payment-mode-panel--net-banks--bank ${
                      selectedMode === bank.code ? 'active-bank' : ''
                    }`}
                    // style={{ width: 100 / trimmedList.length + '%' }}
                    style={{ width: '20%' }}
                    key={bank.code}
                  >
                    <div className="desktop-payment-mode-panel--net-banks--logo">
                      <img
                        className="bank-img"
                        src={bank.image}
                        alt="bank logo"
                      />
                    </div>
                    <div className="desktop-payment-mode-panel--net-banks--name ellipsis">
                      {bank.name}
                    </div>
                  </div>
                );
              })}
              {trimmedList.map(bank => {
                if (selectedMode === bank.code) {
                  return (
                    <div className="saved-wallet-cta" key={bank.code}>
                      <Button
                        className="button button-primary medium"
                        onClick={onPay}
                      >
                        {ctaText}
                      </Button>
                    </div>
                  );
                }
                return false;
              })}
            </div>
            <div className="desktop-payment-mode-panel--cta">
              <Button
                className="desktop-payment-mode-panel--add-card  button action-link more"
                onClick={() => setMoreBanksModal(true)}
              >
                View More Banks
              </Button>
            </div>
          </React.Fragment>
        )}
      </div>
      <div className="desktop-payments-section-divider"></div>
      <Drawer
        title="SELECT YOUR BANK"
        placement="right"
        closable={true}
        onClose={onCancel}
        visible={showMoreBanks}
        destroyOnClose={true}
        maskClosable={false}
        width={500}
        footer={
          <div className="desktop-desktop-more-net-banks--cta">
            <Button
              className="button button-primary full-width large"
              onClick={onPay}
            >
              Proceed to Pay
            </Button>
          </div>
        }
        className="desktop-more-net-banks"
      >
        <Input
          className="desktop-more-net-banks--search-box"
          type={'text'}
          onChange={filterBanks}
          placeholder="Search for your bank"
          autoFocus
          value={searchKey}
          name="searchKey"
          clearText
          search
        />
        <div className="desktop-more-net-banks--list">
          {bankList.map(bank => {
            return (
              <div
                className="desktop-more-net-banks--item"
                key={bank.code}
                onClick={() => selectNetBank(bank.code)}
              >
                <div className="desktop-more-net-banks--name">{bank.name}</div>
                <div className="desktop-more-net-banks--radio">
                  {selectedMode === bank.code ? (
                    <Icon size={20} class="icon-common-radio-selected" />
                  ) : (
                    <Icon size={20} class="icon-common-radio-unselected" />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Drawer>
    </React.Fragment>
  );
};

export default NetBanks;
